<mat-form-field appearance="outline" class="margin date-input" subscriptSizing="dynamic" floatLabel="always">
  @if (showLabels) {
  <mat-label>
    {{ startLabel | translate }}
  </mat-label>
  }

  <input matInput [ngxMatDatetimePicker]="startDatePicker" [value]="startDate" [min]="minDate" [max]="maxDate"
    (dateChange)="onStartDateChange($event)" (timeChange)="onTimeChange($event)"
    [placeholder]="showPlaceholder ? ('dashboard.start_date' | translate) : ''">

  <lib-button matSuffix (click)="startDatePicker.open()" color="none" size="small" icon="today"
    tooltip="{{ 'dashboard.start_date' | translate }}">
  </lib-button>

  <ngx-mat-datetime-picker #startDatePicker [showSpinners]="true" [showSeconds]="showSeconds" [stepHour]="stepHour"
    [stepMinute]="stepMinute" [stepSecond]="stepSecond" [touchUi]="touchUi" [color]="color">
    <ng-template>
      <span>OK</span>
    </ng-template>
  </ngx-mat-datetime-picker>
</mat-form-field>

<mat-form-field appearance="outline" class="date-input" subscriptSizing="dynamic" floatLabel="always">
  @if (showLabels) {
  <mat-label>
    {{ endLabel | translate }}
  </mat-label>
  }

  <input matInput [ngxMatDatetimePicker]="endDatePicker" [value]="endDate" [min]="minDate" [max]="maxDate"
    (dateChange)="onEndDateChange($event)" (input)="onEndInputChange($event)"
    [placeholder]="showPlaceholder ? ('dashboard.end_date' | translate) : ''">

  <lib-button matSuffix (click)="endDatePicker.open()" color="none" size="small" icon="event"
    tooltip="{{ 'dashboard.end_date' | translate }}">
  </lib-button>

  <ngx-mat-datetime-picker #endDatePicker [showSpinners]="true" [showSeconds]="showSeconds" [stepHour]="stepHour"
    [stepMinute]="stepMinute" [stepSecond]="stepSecond" [touchUi]="touchUi" [color]="color">
    <ng-template>
      <span>OK</span>
    </ng-template>
  </ngx-mat-datetime-picker>
</mat-form-field>